import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=18c48f91&scoped=true"
import script from "./AccordionItem.vue?vue&type=script&lang=js"
export * from "./AccordionItem.vue?vue&type=script&lang=js"
import style0 from "@/styles/components/AccordionView/AccordionItem.less?vue&type=style&index=0&id=18c48f91&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c48f91",
  null
  
)

export default component.exports